import {Component, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {EventService} from "../../service/api/event.service";
import {EventResponse} from "../../shared/model/response/event/event-response.model";
import {FilterEventComponent} from "./filterevent/filterevent.component";
import {PageInfo} from "../../shared/model/response/page-info.model";
import {ApiResponse} from "../../shared/model/response/ApiResponse";
import {PaginatorState} from "primeng/paginator";

@Component({
    selector: 'app-events',
    templateUrl: './events.component.html',
    standalone: false
})
export class EventsComponent implements OnInit {

  category: string
  displayError: boolean

  eventResponse: ApiResponse<EventResponse[]>;
  pagination: PageInfo

  readonly types = [
    {padrao: 'people', code: 'PEOPLE', label: 'Pessoas', image: 'type-people.png'},
    {padrao: 'document', code: 'DOCUMENT', label: 'Documentos', image: 'type-document.png'},
    {padrao: 'vehicle', code: 'VEHICLE', label: 'Veículos', image: 'type-vehicle.png'},
    {padrao: 'other', code: 'OTHER', label: 'Diversos', image: 'type-other.png'},
  ]

  private lastFilters: {} = {}

  @ViewChild('eventFilter') eventFilter: FilterEventComponent

  constructor(private route: ActivatedRoute, private router: Router, private eventService: EventService) {
  }

  ngOnInit(): void {

    this.route.queryParams.subscribe({
      next: params => {
        const padrao = (params['padrao'] ?? '').toString().toLowerCase()
        const selected = this.types.find(type => type.padrao === padrao)
        if (!selected) {
          this.router.navigate([], {
            relativeTo: this.route,
            queryParams: {padrao: 'people'},
            queryParamsHandling: 'merge',
            replaceUrl: true
          })
          return
        }
        this.category = selected.code
        this.fetchEvents({'category': this.category})
        this.eventFilter?.form?.get('category')?.setValue(this.category)
      }
    })

  }

  fetchEvents(filters: {}, page?: number) {
    if (!page) page = 0
    this.lastFilters = filters
    this.eventService.getEvents(page, filters)
      .subscribe({
        next: (value) => {
          this.eventResponse = value
          this.pagination = value.pageInfo
        }
      })
  }

  changePageEvent($event: PaginatorState) {
    this.fetchEvents(this.lastFilters, $event.page)
  }

  onCategorySelected(code: string) {
    const selected = this.types.find(type => type.code === code)
    if (!selected || selected.code === this.category) {
      return
    }
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {padrao: selected.padrao},
      queryParamsHandling: 'merge'
    })
  }
}
